import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import FileUploadDropzone from './FileUploadDropzone';
const ControlledFileUploadDropzone = ({ control, name, rules, shouldUnregister, onValueChange, ...rest }) => {
    return (_jsx(Controller, { control: control, name: name, rules: rules, shouldUnregister: shouldUnregister, render: ({ field }) => (_jsx(FileUploadDropzone, { ...rest, value: field.value, onChange: (value) => {
                field.onChange(value);
                onValueChange?.(value);
            } })) }));
};
export default ControlledFileUploadDropzone;
